import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Pagination from 'components/v2/PaginationV2';
import PanelSection from 'components/v2/PanelSection';
import Select from 'components/v2/select';

const PerPage = (props) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid="div-db370b9d"
      className="flex items-center my-auto mr-4 space-x-2"
    >
      <label
        htmlFor="pagination-bar-per-page"
        data-testid="label-122f0293"
        className="form-label"
      >
        {t('PER_PAGE')}
      </label>
      <Select
        id="pagination-bar-per-page"
        items={props.options.map(String)}
        selected={String(props.selectedValue)}
        onSelect={(val) => props.onChange(Number(val))}
        hideLabel
        dataTestId="select-21575e42"
      />
    </div>
  );
};

PerPage.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
};

export default function PaginationBar({
  total,
  page,
  perPage,
  perPageOptions,
  onPageClick,
  onPerPageChange,
  'data-testid': dataTestId,
  children,
}) {
  return (
    <span
      data-testid="span-5106d5a3"
      className="flex justify-between lg:space-x-8 items-center border-b border-gray-200"
    >
      <Pagination
        first
        last
        total={total}
        page={page}
        perPage={perPage}
        onPageClick={onPageClick}
        className="pb-4"
        dataTestId={dataTestId}
      />
      <PanelSection className="flex space-x-2 items-center">
        <PerPage
          options={perPageOptions}
          onChange={onPerPageChange}
          selectedValue={perPage}
        />
        {children}
      </PanelSection>
    </span>
  );
}

PaginationBar.propTypes = {
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  perPageOptions: PropTypes.array.isRequired,
  onPageClick: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  'data-testid': PropTypes.string,
  children: PropTypes.node,
};
